/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {executeLightningWithdrawalInternalAction} from '../api'

export const useMutationExecuteLightningWithdrawalInternalAction = createReactQueryMutationHook('executeLightningWithdrawalInternalAction', executeLightningWithdrawalInternalAction)
